import React from 'react';
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

const Footer = () => {
    return (
        <footer className="bg-gray-50 border-t">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="space-y-4">
              <h3 className="font-poppins font-bold text-xl text-aulanovus-blue">
                Aulanovus
              </h3>
              <p className="font-inter text-sm text-gray-600">
                Transformando el futuro con inteligencia artificial
              </p>
            </div>
  
            <div>
              <h4 className="font-poppins font-semibold text-gray-900 mb-4">Enlaces</h4>
              <ul className="space-y-2">
                {["Inicio", "Servicios", "Sobre Nosotros", "Contacto"].map((item) => (
                  <li key={item}>
                    <Link
                      to={item === "Inicio" ? "/" : `/${item.toLowerCase().replace(" ", "-")}`}
                      className="font-inter text-sm text-gray-600 hover:text-aulanovus-blue transition-colors"
                    >
                      {item}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
  
            <div>
              <h4 className="font-poppins font-semibold text-gray-900 mb-4">Servicios</h4>
              <ul className="space-y-2">
                {[
                  "Desarrollo de IA",
                  "Integración de Soluciones",
                  "Consultoría",
                  "Soporte Técnico",
                ].map((service) => (
                  <li
                    key={service}
                    className="font-inter text-sm text-gray-600 hover:text-aulanovus-blue transition-colors"
                  >
                    {service}
                  </li>
                ))}
              </ul>
            </div>
  
            <div>
              <h4 className="font-poppins font-semibold text-gray-900 mb-4">Contacto</h4>
              <ul className="space-y-3">
                <li className="flex items-center space-x-2">
                  <MapPin className="w-4 h-4 text-aulanovus-green" />
                  <span className="font-inter text-sm text-gray-600">
                    Santiago, Chile
                  </span>
                </li>
                <li className="flex items-center space-x-2">
                  <Phone className="w-4 h-4 text-aulanovus-green" />
                  <span className="font-inter text-sm text-gray-600">
                    +56 9 3913 4811
                  </span>
                </li>
                <li className="flex items-center space-x-2">
                  <Mail className="w-4 h-4 text-aulanovus-green" />
                  <span className="font-inter text-sm text-gray-600">
                    info@aulanovus.com
                  </span>
                </li>
              </ul>
            </div>
          </div>
  
          <div className="mt-8 pt-8 border-t">
            <p className="font-inter text-sm text-center text-gray-600">
              © {new Date().getFullYear()} Aulanovus. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>
    );
};

export default Footer;